import classNames from 'classnames';
import { forwardRef } from 'react';

// Below this, "Zoom / In-person / Phone call / All" can't share a single row.

const rowCss = "r1l1cgbx";
export const LocationButtonsRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const containerCss = "c1p5bvyy";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const allOptionsWrapperCss = "a1yqijrk";
export const allOptionsButtonCss = "a17wsdhy";
export const AllOptionsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(allOptionsWrapperCss, props.className)} />;
});
export const iconSizeCss = "ipooy2d";

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");